import { Result } from 'antd'
import Loader from 'Common/Loader'
import DataGrid, { Column, Pager, Paging, SearchPanel, Summary } from 'devextreme-react/cjs/data-grid'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { GetAllOldGoldPurchaseData } from '../services'
import CustomStore from 'devextreme/data/custom_store'
import ActionButtonsModal from './ActionButtonsModal'
import moment from 'moment'

const OldGoldDataList = () => {
    const [loading, setLoading] = useState(false)
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);

    useEffect(() => {
        const authUserString = localStorage.getItem("authPOSUser");
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const HasPermission = (permission: string): boolean => {
        return permissionDetails.includes(permission);
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const parameterList = new URLSearchParams();

                    if (loadOptions.skip !== undefined) parameterList.append('skip', String(loadOptions.skip));
                    if (loadOptions.take !== undefined) parameterList.append('take', String(loadOptions.take));

                    if (loadOptions.searchValue) {
                        parameterList.append('search', loadOptions.searchValue);
                        parameterList.append('searchOperation', loadOptions.searchOperation || 'contains');
                    }

                    if (loadOptions.sort) parameterList.append('sort', JSON.stringify(loadOptions.sort));
                    if (loadOptions.filter) parameterList.append('filter', JSON.stringify(loadOptions.filter));

                    const response = await GetAllOldGoldPurchaseData(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    return (
        <>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid">

                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Old Gold Purchase List</h5>
                        </Card.Header>
                        <Card.Body className='pt-0'>
                            <DataGrid
                                dataSource={dataSource()}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                                remoteOperations={{ groupPaging: true }}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Paging defaultPageSize={10} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}

                                />
                                <SearchPanel visible={true} width={240} placeholder="Search..." />

                                {(HasPermission("PurchaseOrder.Write") || HasPermission("PurchaseOrder.Delete")) &&
                                    <Column
                                        caption="Action"
                                        width="15%"
                                        cssClass="text-center"
                                        cellRender={({ data }) => (
                                            <div className="d-flex justify-content-center align-items-center gap-2">
                                                <ActionButtonsModal
                                                    selectedId={data.id as string}
                                                />
                                            </div>
                                        )}
                                    />}
                                <Column dataField="poNumber" caption="Po No" dataType="string" />
                                <Column
                                    dataField="poDate"
                                    caption="Po Date"
                                    dataType="date"
                                    format="dd/MM/yyyy"
                                />
                                <Column dataField="customerName" caption="Customer Name" dataType="string" />
                                <Column dataField="salesPersonName" caption="Sales Person Name" dataType="string" />
                                <Column dataField="totalAmount" caption="Total Po Amt" dataType="string" format={{ type: 'fixedPoint', precision: 2 }} />

                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>
    )
}

export default OldGoldDataList
